import useGlobalStore from 'hooks/useGlobalStore';
import useUsers from 'hooks/useUser';

import { CURRENT_USER_ID } from './constants';
import type { FetchCurrentUser, UpdateCurrentUser } from './types';

const useCurrentUser = () => {
    const { fetchUser, isLoading, updateUser } = useUsers();
    const { setValue } = useGlobalStore({
        namespace: 'useCurrentUser'
    });

    const fetchCurrentUser: FetchCurrentUser = async () => {
        const currentUser = await fetchUser({ id: CURRENT_USER_ID });

        setValue({ currentUser });

        return currentUser;
    };

    const updateCurrentUser: UpdateCurrentUser = async ({ user }) => {
        const currentUser = await updateUser({ id: CURRENT_USER_ID, user });

        setValue({ currentUser });

        return currentUser;
    };

    return {
        fetchCurrentUser,
        isLoading,
        updateCurrentUser
    };
};

export default useCurrentUser;
